import Error from '../model/Error';
import FeeTableHistory from '../dto/FeeTableHistory';
import axios from 'axios';

export default class FeeTableHistoryRepository {
    static create(kindergartenId, feeTableHistory, feeTable) {
        return new Promise((resolve, reject) => {
            axios
                .post(`/kindergartens/${kindergartenId}/fee-table-histories`, feeTableHistory.toData(feeTable))
                .then((response) => resolve(response))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static update(feeTableHistory, feeTable) {
        return new Promise((resolve, reject) => {
            axios
                .patch(`/fee-table-histories/${feeTableHistory.id}`, feeTableHistory.toData(feeTable))
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static precheckAdjustingServiceEntries(feeTableHistory, feeTable) {
        return new Promise((resolve, reject) => {
            axios
                .post(`/fee-table-histories/${feeTableHistory.id}/forecast`, feeTableHistory.toData(feeTable))
                .then((response) => resolve(response.data))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static delete(feeTableHistoryId) {
        return new Promise((resolve, reject) => {
            axios
                .delete(`/fee-table-histories/${feeTableHistoryId}`)
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static findByKindergarten(kindergartenId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/kindergartens/${kindergartenId}/fee-table-histories`)
                .then((response) => resolve(response.data.data.map((data) => FeeTableHistory.fromData(data))))
                .catch((error) => {
                    return reject(Error.fromResponse(error.response));
                });
        });
    }
}
